import {
  ExitGuideButton,
  PreviousStepButton,
  SkipStepButton,
} from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { useEffect, useState } from 'react';
import { AddAlert } from '../../../../../../../component';
import { useDispatch } from 'react-redux';
import {
  advanceToStep,
  setCanAdvance,
  setCurrentProgressTo,
  setLayoutsValuationSecondaryResponse,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import {
  removeClusters,
  removeMarkers,
  setDisplayCharts,
  setIsActive,
  setIsActiveRightSidebar,
} from '../../../../../redux/dashboardActions';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import { postStudyStep } from '../../../../redux/studies.controller';
import {
  loaded,
  loading,
} from '../../../../../../../layout/redux/layoutActions';
import { LayoutValuationResponse } from '../../../../redux/studies.model';

export const UnderstandSecondaryMarket: React.FC = () => {
  const [includeHeatmap, setIncludeHeatmap] = useState<boolean>(true);
  const dispatch = useDispatch();
  const {
    currentStep,
    id,
    layoutsValuationPayload,
    layoutsValuationPrimaryResponse,
  } = useTypedSelector(studiesSelector);
  const { displayCharts } = useTypedSelector((state) => state.dashboardState);
  useEffect(() => {
    dispatch([
      setCurrentProgressTo(2),
      setIsActive({ name: 'menuAction', value: '2' }),
      setIsActiveRightSidebar({ name: 'menuAction', value: '2' }),
      setDisplayCharts(null),
      removeMarkers(),
      removeClusters(),
    ]);
  }, []);
  useEffect(() => {
    if (displayCharts === 'secondaryMarket') {
      dispatch(setCanAdvance(true));
    }
  }, [displayCharts]);
  const removeNulls = (
    responseSecondary: LayoutValuationResponse,
    responsePrimary: LayoutValuationResponse | null
  ): LayoutValuationResponse | null => {
    if (!responsePrimary) {
      return null;
    }
    const primaryIds = responsePrimary.map((el) => el.id);
    const secondaryIds = responseSecondary.map((el) => el.id);
    const invalidResponses = secondaryIds.filter(
      (el) => !primaryIds.includes(el)
    );
    const invalidsRemoved = responseSecondary.filter(
      (el) => !invalidResponses.includes(el.id)
    );
    return invalidsRemoved;
  };
  const handleClickAdvance = async () => {
    dispatch(loading());
    try {
      if (layoutsValuationPayload) {
        const response = await postStudyStep(3, id, {
          layouts: layoutsValuationPayload,
        });
        const validResponses = removeNulls(
          response.secondary_market,
          layoutsValuationPrimaryResponse
        );
        dispatch([
          advanceToStep(currentStep.nextStep),
          setIsActiveRightSidebar({ name: 'menuAction', value: '0' }),
          setLayoutsValuationSecondaryResponse(validResponses),
          AddAlert('success', 'Avaliação do mercado secundário concluída'),

          loaded(),
        ]);
      }
    } catch (e) {
      dispatch([loaded()]);
    }
  };
  const handleClickSkipStep = () => {
    dispatch([
      advanceToStep('calculateVGV'),
      setIsActiveRightSidebar({ name: 'menuAction', value: '0' }),
      setLayoutsValuationSecondaryResponse(null),
    ]);
  };
  return (
    <div>
      <p className="helper-text">{nls.studyCreationGuide.steps.step3.helper}</p>
      {/*Comentado até implementação da feature Mapas de calor*/}
      {/* <div>
        <Checkbox
          action={() => setIncludeHeatmap(!includeHeatmap)}
          cy="IncludeHeatmapSecondaryMarket"
          checked={includeHeatmap}
          name=""
          label={nls.studyCreationGuide.steps.step3.includeHeatmap}
        />
      </div> */}
      <SkipStepButton callback={handleClickSkipStep} />
      <div className="study-creation-guide__buttons-container">
        <div>
          <ExitGuideButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <PreviousStepButton />
          <button
            className="btn normal primary"
            data-cy="StudyCreationGuideNextStep"
            onClick={handleClickAdvance}
            // disabled={!currentStep.canAdvance}
          >
            {nls.studyCreationGuide.buttons.evaluate}
          </button>
        </div>
      </div>
    </div>
  );
};
